export function initMenuComparison() {
  const comparison = document.getElementById('menu-comparison');
  if (!comparison) return;

  const cards = Array.from(comparison.querySelectorAll<HTMLElement>('[data-menu-card]'));
  const toggles = Array.from(comparison.querySelectorAll<HTMLButtonElement>('[data-menu-toggle]'));

  const setActiveMenu = (menu: string) => {
    comparison.dataset.activeMenu = menu;

    cards.forEach((card) => {
      const isActive = card.dataset.menuCard === menu;
      card.setAttribute('aria-pressed', String(isActive));
    });

    toggles.forEach((toggle) => {
      const isActive = toggle.dataset.menuToggle === menu;
      toggle.classList.toggle('is-active', isActive);
      toggle.setAttribute('aria-pressed', String(isActive));
    });
  };

  cards.forEach((card) => {
    card.addEventListener('click', () => {
      const menu = card.dataset.menuCard;
      if (menu) setActiveMenu(menu);
    });
  });

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const menu = toggle.dataset.menuToggle;
      if (menu) setActiveMenu(menu);
    });
  });

  setActiveMenu(comparison.dataset.activeMenu ?? 'digital');
}
